import React, { useState } from "react";
import { Row, Col, Label, Input, Card } from "reactstrap";

const PaymentInfo = ({ onBack, onNext }) => {
  const [selectedMethod, setSelectedMethod] = useState("creditCard");

  const handlePaymentMethodChange = (method) => {
    setSelectedMethod(method);
  };

  return (
    <div>
      <h5 className="mb-1">Payment Selection</h5>
      <p className="text-muted mb-4">
        Please select and enter your billing information
      </p>
      <Row className="g-4">
        <Col lg={4} sm={6}>
          <div className="form-check card-radio">
            <Input
              id="paymentMethod02"
              name="paymentMethod"
              type="radio"
              className="form-check-input"
              defaultChecked
              onChange={() => handlePaymentMethodChange("creditCard")}
            />
            <Label className="form-check-label" htmlFor="paymentMethod02">
              <span className="fs-16 text-muted me-2">
                <i className="ri-bank-card-fill align-bottom"></i>
              </span>
              <span className="fs-14 text-wrap">Credit / Debit Card</span>
            </Label>
          </div>
        </Col>
        <Col lg={4} sm={6}>
          <div className="form-check card-radio">
            <Input
              id="paymentMethod03"
              name="paymentMethod"
              type="radio"
              className="form-check-input"
              onChange={() => handlePaymentMethodChange("cashOnDelivery")}
            />
            <Label className="form-check-label" htmlFor="paymentMethod03">
              <span className="fs-16 text-muted me-2">
                <i className="ri-money-dollar-box-fill align-bottom"></i>
              </span>
              <span className="fs-14 text-wrap">Cash on Delivery</span>
            </Label>
          </div>
        </Col>
      </Row>
      {selectedMethod === "creditCard" && (
        <Card className=" p-4 border shadow-none mb-0 mt-4">
          <Row className="gy-3">
            <Col md={12}>
              <Label htmlFor="cc-name" className="form-label">
                Name on card
              </Label>
              <Input
                type="text"
                className="form-control"
                id="cc-name"
                placeholder="Enter name"
              />
              <small className="text-muted">
                Full name as displayed on card
              </small>
            </Col>
            <Col md={6}>
              <Label htmlFor="cc-number" className="form-label">
                Credit card number
              </Label>
              <Input
                type="text"
                className="form-control"
                id="cc-number"
                placeholder="xxxx xxxx xxxx xxxx"
              />
            </Col>
            <Col md={3}>
              <Label htmlFor="cc-expiration" className="form-label">
                Expiration
              </Label>
              <Input
                type="text"
                className="form-control"
                id="cc-expiration"
                placeholder="MM/YY"
              />
            </Col>
            <Col md={3}>
              <Label htmlFor="cc-cvv" className="form-label">
                CVV
              </Label>
              <Input
                type="text"
                className="form-control"
                id="cc-cvv"
                placeholder="xxx"
              />
            </Col>
          </Row>
        </Card>
      )}
      <div className="d-flex align-items-start gap-3 mt-4">
        <button
          type="button"
          className="btn btn-light btn-label previestab"
          onClick={onBack}
        >
          <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2"></i>
          Back to Info
        </button>

        <button
          type="button"
          className="btn btn-primary btn-label right ms-auto nexttab"
          onClick={onNext}
        >
          Complete Order
        </button>
      </div>
    </div>
  );
};

export default PaymentInfo;
